const {Component} = require("react");
const $ = require("helpers/element");

class MobileAvatar extends Component {

	openAvatar = (e) => {
		e.preventDefault();
		e.stopPropagation();

		const nav = document.querySelector('body');
		if (nav == undefined) {
			return;
		}

		$(nav).toggleClass('open-nav');

		const file = document.querySelector('#avatarFileInput');
		if (file == undefined) {
			return;
		}

		file.click();
	}

	render() {
		return (
			<button type="button" className="btn" onClick={this.openAvatar} >
				Profilbillede
			</button>
		);
	}

}

module.exports = MobileAvatar;



// WEBPACK FOOTER //
// ./resources/js/components/backend/MobileAvatar.js